
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { UserService } from '@/services/index'
import { omit } from 'lodash'

@Component({
    name: 'SearchLogs',
    components: {
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private searchLogs = []
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = true 

    private mounted() {
        this.getSearchLogs()
    }

    private async getSearchLogs() {
        const params = { page_index: this.pageIndex, page_size: this.pageSize }
        const result = await UserService.getNmUserSLogs(params)
        if (result.status === 200) {
            this.searchLogs = result.data.logs
            this.pageTotal = result.data.page_total
        }
        this.loading = false
    }

    private onCurrentChange(page: number) {
        this.pageIndex = page
        this.scrollEl.scrollToTop(this.getSearchLogs)
    }

    private isEmptySearch(row: any) {
        const searchCondition = omit(row, ['created_at', 'search_type', 'user'])
        let validFields = Object.values(searchCondition).filter(Boolean)
        return !validFields.length
    }
}
